import { UserDto } from '@act/shared/data-transfer-objects';
import {
  CollapsibleCardContent,
  CollapsibleCardHeader,
  IconLibrary,
} from '@act/storybook';
import BeenHereIcon from '@mui/icons-material/Beenhere';
import { Typography } from '@mui/material';
import useEmailAddressDialog from 'react-components/dialog-forms/hooks/use-email-address-dialog';
import { LabeledDatum } from 'toolkit/styles/dataDisplay';
import { CenterVerticalAlign } from '../common-layout';

export interface EmailAddressContactCardProps {
  member: UserDto;
}

const EmailAddressContactCard = ({ member }: EmailAddressContactCardProps) => {
  const openEmailAddressDialog = useEmailAddressDialog();
  const emailAddresses = member?.emailAddresses || [];

  return (
    <>
      <CollapsibleCardHeader
        title="Email address"
        titleTypographyVariant="subheadMedium"
        avatar={<IconLibrary iconName="Envelope" size={24} />}
        actions={[
          {
            display: 'Edit email address',
            disabled: !emailAddresses.length,
            ddTrackingName: 'edit-email-address-button',
            callback: () =>
              openEmailAddressDialog({
                mode: 'Edit',
                memberId: member?.id,
                emailAddresses,
              }),
          },
        ]}
        secondaryActions={[
          {
            display: 'Add email address',
            ddTrackingName: 'add-email-address-button',
            callback: () =>
              openEmailAddressDialog({
                mode: 'Add',
                memberId: member?.id,
                emailAddresses,
              }),
          },
          {
            display: 'Set primary email address',
            disabled: !emailAddresses.length,
            ddTrackingName: 'set-primary-email-address-button',
            callback: () =>
              openEmailAddressDialog({
                mode: 'Set primary',
                memberId: member?.id,
                emailAddresses,
              }),
          },
          {
            display: 'Delete email address',
            disabled: !emailAddresses.length,
            ddTrackingName: 'delete-email-address-button',
            callback: () =>
              openEmailAddressDialog({
                mode: 'Delete',
                memberId: member?.id,
                emailAddresses,
              }),
          },
        ]}
      />
      <CollapsibleCardContent twoColumn>
        {!emailAddresses.length && <Typography>No record found</Typography>}
        {!!emailAddresses.length &&
          emailAddresses.map(ea => (
            <LabeledDatum
              key={`${ea.description}-${ea.email}`}
              label={
                <CenterVerticalAlign>
                  {ea.description}
                  {ea.primary && (
                    <BeenHereIcon
                      fontSize="small"
                      color="primary"
                      sx={{ marginLeft: '4px' }}
                    />
                  )}
                </CenterVerticalAlign>
              }
              datum={ea.email}
            />
          ))}
      </CollapsibleCardContent>
    </>
  );
};

export default EmailAddressContactCard;
